// ImmiPro — Mock data for Phase 0 (frontend-only)
// All data here is fictional and used purely for UI/UX demonstration.

export const CURRENT_USER = {
  id: 'u_001',
  name: 'Priya Nair',
  role: 'Principal RMA',
  marn: '2118541',
  email: 'priya@nairmigration.com.au',
  firm: 'Nair Migration Advisory',
  avatar: 'PN',
};

export const KPIS = [
  { label: 'Open matters', value: 34, delta: '+3 this week', tone: 'positive' },
  { label: 'Awaiting client action', value: 12, delta: '4 overdue', tone: 'warn' },
  { label: 'Trust balance', value: 'A$142,500', delta: 'Reconciled', tone: 'positive' },
  { label: 'Grant rate (12mo)', value: '94%', delta: 'vs. DHA median 79%', tone: 'positive' },
];

export const SUBCLASSES = [
  { code: '482', name: 'Skills in Demand (TSS)', category: 'Employer' },
  { code: '186', name: 'Employer Nomination (ENS)', category: 'Employer' },
  { code: '189', name: 'Skilled Independent', category: 'Points' },
  { code: '190', name: 'Skilled Nominated', category: 'Points' },
  { code: '491', name: 'Skilled Work Regional', category: 'Points' },
  { code: '820', name: 'Partner (onshore)', category: 'Family' },
  { code: '801', name: 'Partner (permanent)', category: 'Family' },
  { code: '500', name: 'Student', category: 'Student' },
  { code: '485', name: 'Temporary Graduate', category: 'Student' },
  { code: '600', name: 'Visitor', category: 'Visitor' },
];

export const ASSESSING_BODIES = [
  { code: 'CPAA', name: 'CPA Australia', occupations: ['Accountant (General)', 'Management Accountant', 'Taxation Accountant'], site: 'cpaaustralia.com.au' },
  { code: 'IPA', name: 'Institute of Public Accountants', occupations: ['Accountant (General)', 'External Auditor'], site: 'publicaccountants.org.au' },
  { code: 'CAANZ', name: 'Chartered Accountants ANZ', occupations: ['Accountant (General)', 'External Auditor'], site: 'charteredaccountantsanz.com' },
  { code: 'VETASSESS', name: 'VETASSESS', occupations: ['Marketing Specialist', 'HR Adviser', 'Chef', 'Cabinetmaker'], site: 'vetassess.com.au' },
  { code: 'EA', name: 'Engineers Australia', occupations: ['Civil Engineer', 'Mechanical Engineer', 'Software Engineer'], site: 'engineersaustralia.org.au' },
  { code: 'ACS', name: 'Australian Computer Society', occupations: ['Software Engineer', 'ICT Business Analyst', 'Systems Analyst'], site: 'acs.org.au' },
  { code: 'AHPRA', name: 'AHPRA', occupations: ['Registered Nurse', 'General Practitioner', 'Physiotherapist'], site: 'ahpra.gov.au' },
  { code: 'TRA', name: 'Trades Recognition Australia', occupations: ['Electrician', 'Plumber', 'Carpenter'], site: 'tradesrecognitionaustralia.gov.au' },
];

export const OCCUPATIONS = [
  { anzsco: '221111', name: 'Accountant (General)', list: 'MLTSSL', assessingBody: 'CPAA' },
  { anzsco: '261313', name: 'Software Engineer', list: 'MLTSSL', assessingBody: 'ACS' },
  { anzsco: '233211', name: 'Civil Engineer', list: 'MLTSSL', assessingBody: 'EA' },
  { anzsco: '254411', name: 'Registered Nurse', list: 'MLTSSL', assessingBody: 'AHPRA' },
  { anzsco: '351311', name: 'Chef', list: 'MLTSSL', assessingBody: 'VETASSESS' },
  { anzsco: '341111', name: 'Electrician', list: 'MLTSSL', assessingBody: 'TRA' },
];

export const MATTERS = [
  {
    id: 'M-9910', ref: 'NM-2025-0142', applicant: 'John Smith', country: 'United Kingdom',
    subclass: '186', stream: 'Direct Entry', stage: 'IN_PREP', rag: 'GREEN',
    assignedTo: 'Priya Nair', occupation: 'Software Engineer', assessingBody: 'ACS',
    lastAction: '2 hours ago', nextDeadline: '2025-08-14', deadlineLabel: 'Medical exam',
    trustBalance: 1170, feeAgreementSigned: true, consumerGuideSigned: true,
    lodgementDate: null, decisionDate: null,
  },
  {
    id: 'M-9912', ref: 'NM-2025-0138', applicant: 'Maria Alves', country: 'Brazil',
    subclass: '820', stream: null, stage: 'LODGED', rag: 'GREEN',
    assignedTo: 'Priya Nair', occupation: null, assessingBody: null,
    lastAction: 'yesterday', nextDeadline: '2025-11-02', deadlineLabel: 'BVA in effect',
    trustBalance: 41330, feeAgreementSigned: true, consumerGuideSigned: true,
    lodgementDate: '2025-06-19', decisionDate: null,
  },
  {
    id: 'M-9915', ref: 'NM-2025-0131', applicant: 'TechCorp Australia', country: 'AU (Sponsor)',
    subclass: '482', stream: 'Skills in Demand — Core', stage: 'IN_PREP', rag: 'AMBER',
    assignedTo: 'Priya Nair', occupation: 'ICT Business Analyst', assessingBody: 'ACS',
    lastAction: '3 days ago', nextDeadline: '2025-08-05', deadlineLabel: 'Nomination lodgement',
    trustBalance: 100000, feeAgreementSigned: true, consumerGuideSigned: true,
    lodgementDate: null, decisionDate: null,
  },
  {
    id: 'M-9918', ref: 'NM-2025-0128', applicant: 'Wei Chen', country: 'China',
    subclass: '500', stream: 'Higher Education', stage: 'ENGAGED', rag: 'GREEN',
    assignedTo: 'Priya Nair', occupation: null, assessingBody: null,
    lastAction: '5 days ago', nextDeadline: '2025-09-01', deadlineLabel: 'CoE upload',
    trustBalance: 3400, feeAgreementSigned: true, consumerGuideSigned: true,
    lodgementDate: null, decisionDate: null,
  },
  {
    id: 'M-9922', ref: 'NM-2025-0121', applicant: 'Amara Okafor', country: 'Nigeria',
    subclass: '189', stream: null, stage: 'INTAKE', rag: 'RED',
    assignedTo: 'Priya Nair', occupation: 'Registered Nurse', assessingBody: 'AHPRA',
    lastAction: '1 hour ago', nextDeadline: '2025-08-01', deadlineLabel: 'Consumer Guide sign-off',
    trustBalance: 0, feeAgreementSigned: false, consumerGuideSigned: false,
    lodgementDate: null, decisionDate: null,
  },
  {
    id: 'M-9925', ref: 'NM-2025-0115', applicant: 'Rahul Verma', country: 'India',
    subclass: '485', stream: 'Post-Study Work', stage: 'DECIDED', rag: 'GREEN',
    assignedTo: 'Priya Nair', occupation: 'Accountant (General)', assessingBody: 'CPAA',
    lastAction: '2 weeks ago', nextDeadline: null, deadlineLabel: 'Granted',
    trustBalance: 0, feeAgreementSigned: true, consumerGuideSigned: true,
    lodgementDate: '2025-04-10', decisionDate: '2025-06-28',
  },
];

export const CHECKLIST_186_DE = [
  { section: 'Identity', items: [
    { id: 'i1', label: 'Passport bio-data page', done: true, source: 'DHA' },
    { id: 'i2', label: 'National ID (if applicable)', done: true, source: 'DHA' },
    { id: 'i3', label: 'Change of name evidence', done: false, source: 'DHA', na: true },
  ]},
  { section: 'Skills Assessment', items: [
    { id: 's1', label: 'ACS skills assessment — positive outcome', done: true, source: 'ACS', doc: 'acs-outcome-2025-05-11.pdf' },
    { id: 's2', label: 'Reference letters (min 2, on letterhead)', done: true, source: 'ACS' },
    { id: 's3', label: 'Payslip evidence (last 12 months)', done: false, source: 'ACS' },
  ]},
  { section: 'English Proficiency', items: [
    { id: 'e1', label: 'IELTS / PTE / TOEFL result (min competent English)', done: true, source: 'DHA' },
  ]},
  { section: 'Employment (Direct Entry)', items: [
    { id: 'w1', label: 'Employment references — 3 years full-time equivalent', done: true, source: 'DHA' },
    { id: 'w2', label: 'Position description on employer letterhead', done: true, source: 'DHA' },
    { id: 'w3', label: 'Contract of employment (signed)', done: false, source: 'DHA' },
  ]},
  { section: 'Health & Character', items: [
    { id: 'h1', label: 'Medical exam (Bupa) — booking confirmation', done: false, source: 'DHA' },
    { id: 'h2', label: 'AFP police check', done: false, source: 'DHA' },
    { id: 'h3', label: 'Overseas police clearance (each country > 12mo since age 16)', done: false, source: 'DHA' },
  ]},
];

export const TIMELINE_M9910 = [
  { at: '2025-07-28 09:12', actor: 'Priya', kind: 'ai', text: 'AI Copilot suggested ACS as the correct assessing body for Software Engineer (ANZSCO 261313).' },
  { at: '2025-07-26 14:05', actor: 'Client', kind: 'doc', text: 'John uploaded acs-outcome-2025-05-11.pdf (Skills Assessment — positive).' },
  { at: '2025-07-24 11:00', actor: 'Priya', kind: 'note', text: 'Phone call — 22 min. Confirmed employer will provide 3 years of payslips by Aug 5.' },
  { at: '2025-07-22 08:30', actor: 'System', kind: 'checklist', text: 'Checklist auto-updated: DHA published revision to Direct Entry evidence list (LIN 25/041).' },
  { at: '2025-07-20 16:45', actor: 'Client', kind: 'sign', text: 'John e-signed the Consumer Guide and Fee Agreement.' },
  { at: '2025-07-20 10:00', actor: 'Priya', kind: 'note', text: 'Matter created from lead — Direct Entry pathway confirmed.' },
];

export const TRUST_LEDGER = [
  { date: '2025-07-20', ref: 'RCPT-1042', desc: 'Initial retainer — John Smith', debit: 0, credit: 4500, balance: 4500 },
  { date: '2025-07-22', ref: 'DISB-0221', desc: 'ACS assessment fee', debit: 550, credit: 0, balance: 3950 },
  { date: '2025-07-25', ref: 'DISB-0223', desc: 'IELTS booking (client-paid, refund)', debit: 0, credit: 340, balance: 4290 },
  { date: '2025-07-28', ref: 'RCPT-1055', desc: 'Top-up — John Smith', debit: 0, credit: 2000, balance: 6290 },
];

export const RECON_REPORT = {
  period: '30 June 2025',
  bsb: '062-900', account: '1044-2219',
  cashbookBalance: 142500,
  outstandingChecks: [{ ref: 'Chq #8821', desc: 'DHA filing fee — V. Patel', amount: 1200 }],
  depositsInTransit: [{ desc: 'Deposit cleared bank, not yet invoiced', amount: -500 }],
  adjustedInternal: 143200,
  bankStatement: 143200,
  variance: 0,
  ledgerSum: 142500,
  status: 'RECONCILED',
};

export const POLICY_ALERTS = [
  { id: 'p1', source: 'DHA', title: 'LIN 25/041 — Direct Entry evidence list updated', published: '2025-07-22', summary: 'Revised employment reference format now requires ANZSCO-aligned duties list. Impacts 8 open 186 DE matters.', impacted: 8 },
  { id: 'p2', source: 'OMARA', title: 'CPD hours confirmation window opens 1 August', published: '2025-07-25', summary: 'Annual CPD confirmation window opens. All active RMAs must confirm 10 hours completed by 30 September.', impacted: 1 },
  { id: 'p3', source: 'ACS', title: 'New RPL processing timeframe: 12 weeks', published: '2025-07-18', summary: 'ACS Recognition of Prior Learning submissions now expected to take 12 weeks (was 8). Adjust client expectations for Software Engineer applicants.', impacted: 4 },
  { id: 'p4', source: 'LegEnd', title: 'Migration Regulations 1994 — reg 2.72 amended', published: '2025-07-12', summary: 'Amendments to nomination validity provisions for 482 Skills in Demand. Review any pending TSS nominations.', impacted: 3 },
];

export const AI_SUGGESTIONS = {
  pathway: {
    input: { age: 32, occupation: 'Software Engineer', english: 'Proficient (PTE 79+)', experience: '6 years', qualification: 'B.Eng Computer Science' },
    output: [
      { rank: 1, subclass: '189', confidence: 88, reason: 'ANZSCO 261313 on MLTSSL; likely 90+ points; no state dependency.' },
      { rank: 2, subclass: '190', confidence: 78, reason: 'Higher certainty via VIC/NSW nomination; requires state occupation list check.' },
      { rank: 3, subclass: '482', confidence: 65, reason: 'Employer-sponsored fallback if points fall short; requires nominating employer.' },
    ],
  },
  rfiDraft: 'Dear Case Officer,\n\nWe respond to the Department\'s Request for Further Information dated 24 July 2025 regarding matter [REF]. Please find enclosed:\n\n1. Updated employment reference from the applicant\'s current employer, dated 28 July 2025, on company letterhead, confirming the position title, ANZSCO-aligned duties, hours per week and length of service.\n\n2. Payslip evidence for the 12-month period 1 July 2024 to 30 June 2025.\n\n3. Updated statutory declaration addressing the specific matters raised.\n\nWe respectfully submit that the applicant continues to satisfy the requirements of subclass 186 (Direct Entry stream). We are happy to provide any further clarification.\n\nYours faithfully,\nPriya Nair — MARN 2118541',
};

export const PRICING = [
  { tier: 'Solo Starter', price: 49, unit: '/mo', target: 'New / solo RMA', matters: 25, users: 1, ai: 100, popular: false, features: ['Core CRM & pipeline', 'Matter & checklist engine', 'Document vault', 'Client portal', 'Trust accounting (OMARA)', 'Email support'] },
  { tier: 'Growth', price: 149, unit: '/user/mo', target: 'Boutique firm', matters: 250, users: 5, ai: 500, popular: true, features: ['Everything in Solo', 'AI Copilot native', 'Practice analytics', 'Xero + Stripe live', 'Policy Pulse alerts', 'Priority support'] },
  { tier: 'Firm', price: 249, unit: '/user/mo', target: 'Mid-size firm', matters: 'Unlimited', users: 20, ai: 2000, popular: false, features: ['Everything in Growth', 'Public API + webhooks', 'Multi-office', 'Zapier connector', 'Custom workflows', 'Dedicated CSM'] },
  { tier: 'Enterprise', price: null, unit: 'Custom', target: 'Big-4 / corporate', matters: 'Unlimited', users: 'Unlimited', ai: 'Unlimited', popular: false, features: ['Everything in Firm', 'SSO + SCIM', 'Self-hosted option', 'Custom SLAs', 'White-label portal', 'Named success team'] },
];

export const TESTIMONIALS = [
  { quote: 'ImmiPro got me OMARA-audit-ready in an afternoon. The occupation-to-assessing-body auto-mapping alone saves me 3 hours per client.', name: 'Priya N.', role: 'Solo RMA, Sydney' },
  { quote: 'The timeline portal ended the “what\'s the status?” email loop. Our clients love it. Our team loves it more.', name: 'Marcus D.', role: 'Principal, Boutique Firm — Melbourne' },
  { quote: 'Three-way trust reconciliation in one click. Our auditor asked what changed. This is what changed.', name: 'Sandra L.', role: 'Corporate Mobility Lead, Big-4' },
];
